import { Injectable } from '@angular/core';
import { databases, ID } from '../config/appwrite';
import { environment } from '../../../environments/environment';
import { Query } from 'appwrite';
import { Convenio } from '../models';

@Injectable({
  providedIn: 'root'
})
export class PagosPaquetesService {
  private collectionId = "paquetes_pagos";
  private DATABASE_NAME = environment.databaseName;

  constructor() { }


  /**
   *getData
   * @returns
   */
  getData() {
    return databases.listDocuments(
      this.DATABASE_NAME,
      this.collectionId
    );
  }

  /**
   * @createDocument()
   * @param data
   * @returns
   */
  createDocument(data: any) {
    return databases.createDocument(this.DATABASE_NAME, this.collectionId, ID.unique(), data);
  }

  getDocument(idDocument: string) {
    return databases.getDocument(this.DATABASE_NAME, this.collectionId, idDocument);
  }
  
  /**
   * Consulta los pagos de una lista de paquetes adquiridos.
   * Se busca por la referencia ("p_" + idPaqueteAdquirido) porque es el
   * atributo que se guarda al crear el pago en comprarPaquete().
   * @param idsPaquetesAdquiridos
   * @returns
   */
  getDataByPaquetesAdquiridos(idsPaquetesAdquiridos: string[]) {
    if (!idsPaquetesAdquiridos || idsPaquetesAdquiridos.length === 0) {
      return Promise.resolve([]);
    }

    const referencias = idsPaquetesAdquiridos.map((id) => "p_" + id);

    return databases
      .listDocuments(this.DATABASE_NAME, this.collectionId, [
        Query.equal("referencia", referencias),
        Query.limit(100),
      ])
      .then((response) => response.documents);
  }

  /**
 * @getDocuments()
 * @param idEspecialista
 * @returns
 */
  getDataByPaciente(idEmpresa: string): Promise<Convenio[]> {
    return databases.listDocuments<Convenio>(
      this.DATABASE_NAME,
      this.collectionId,
      [Query.equal('idEmpresa', [idEmpresa])]
    ).then(response => response.documents);
  }

}
